import { useQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';

import { callService } from '@api/caller';
import { ListingBannerViewModel } from '@api/index';

/**
 * Hook to fetch listing banner data for hotel/tour listing pages
 */
export const useListingBanner = () => {
  const params = useParams();
  const slug = params?.slug as string;

  const { data, isLoading, isError } = useQuery<ListingBannerViewModel>(
    ['listingBanner', slug],
    async () => {
      if (!slug) {
        return { id: null, items: null, name: null };
      }

      return callService('SfContentsService', 'getListingBanners', {
        slug,
      });
    },
    {
      enabled: Boolean(slug),
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: false,
    }
  );

  return {
    banner: data,
    isLoading,
    isError,
  };
};
